var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 160,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 159V1H95.5858L119 24.4142V159H1Z",
    fill: "white",
    stroke: "#1A237E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 2V24H118",
    stroke: "#1A237E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52.0001C91.9996 51.4085 91.8681 50.8244 91.6148 50.2898C91.3615 49.7552 90.9928 49.2835 90.5352 48.9085C90.0776 48.5336 89.5426 48.2648 88.9686 48.1216C88.3947 47.9783 87.7961 47.9641 87.216 48.0801L47.216 56.0801C46.3096 56.2613 45.4938 56.7508 44.9075 57.4654C44.3212 58.1801 44.0006 59.0757 44 60.0001V96.4561C42.6887 96.1505 41.3464 95.9975 40 96.0001C33.372 96.0001 28 99.5801 28 104C28 108.42 33.372 112 40 112C46.628 112 52 108.42 52 104V71.2801L84 64.8801V88.4561C82.6887 88.1505 81.3464 87.9975 80 88.0001C73.372 88.0001 68 91.5801 68 96.0001C68 100.42 73.372 104 80 104C86.628 104 92 100.42 92 96.0001V52.0001Z",
    fill: "#1A237E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.625ae505c9bf729b4f450b82cc623250.svg";
export { ForwardRef as ReactComponent };